import { render, staticRenderFns } from "./inspectionManagement.vue?vue&type=template&id=936d7ab2&scoped=true"
import script from "./inspectionManagement.vue?vue&type=script&lang=js"
export * from "./inspectionManagement.vue?vue&type=script&lang=js"
import style0 from "./inspectionManagement.vue?vue&type=style&index=0&id=936d7ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936d7ab2",
  null
  
)

export default component.exports